/**
 * 스케줄 변경 알림 버스. "새 Schedule" 창(별도 FullscreenWindow)이 생성을 마치면 목록 페이지가
 * 목록을 다시 받게 연결한다.
 *
 * 창과 페이지는 컴포넌트 트리가 서로 달라 props 로 연결할 수 없다. 목록 컨트롤러를 전역
 * 싱글턴으로 만들면 페이지를 떠나도 목록 상태가 남는다. 그래서 신호만 전역으로 두고 데이터는
 * 페이지가 가진다.
 */

const target = new EventTarget();
const SCHEDULE_CHANGED_EVENT = "hatchery:schedule-changed";

export function notifyScheduleChanged(): void {
  target.dispatchEvent(new Event(SCHEDULE_CHANGED_EVENT));
}

export function subscribeScheduleChanged(listener: () => void): () => void {
  target.addEventListener(SCHEDULE_CHANGED_EVENT, listener);
  return () => target.removeEventListener(SCHEDULE_CHANGED_EVENT, listener);
}
